import React from 'react'
import ReactDOM from 'react-dom'
import * as serviceWorker from './serviceWorker'

import './assets/scss/style/Style.scss'
import './assets/scss/Common.scss'

// Redux
import { Provider } from 'react-redux'

// App Redux and Routers
import store from './AppReducer'
import AppRouter from './AppRouter'

// Services
import AxiosService, { setTenantId } from 'util/services/AxiosService'
AxiosService()

const tenantId = window.location.origin.split('://').pop()?.split('.').shift() || 'rise'
setTenantId(tenantId)

export function scrollTop (): void {
  document.querySelector('.layout-panel .content')?.scrollTo(0, 0)
}

ReactDOM.render(
  <Provider store={store}>
    <AppRouter />
  </Provider>,
  document.getElementById('root')
)

serviceWorker.unregister()
